import { render, staticRenderFns } from "./login-with-factor.vue?vue&type=template&id=b6fc65cc&scoped=true&"
import script from "./login-with-factor.vue?vue&type=script&lang=js&"
export * from "./login-with-factor.vue?vue&type=script&lang=js&"
import style0 from "./login-with-factor.vue?vue&type=style&index=0&id=b6fc65cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fc65cc",
  null
  
)

export default component.exports